export default __webpack_public_path__ + "static/media/trustedAdvisor.7a98bb9a.svg";